import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=f1b3a0d4&scoped=true&"
import script from "./project_list.vue?vue&type=script&lang=js&"
export * from "./project_list.vue?vue&type=script&lang=js&"
import style0 from "./project_list.vue?vue&type=style&index=0&id=f1b3a0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b3a0d4",
  null
  
)

export default component.exports